const BLACK_FRIDAY = {
  MY_BF_PAGE: {
    GA_EVENT_CATEGORY: 'my_black_friday_page',
    SAVING_GAME_TAB: 'Jogo da Economia',
    OFFERS_TAB: 'Ofertas',
    COUPONS_TAB: 'Cupons',
  },
  CATEGORY_NAME: 'Black Friday',
  LANDING_TYPE: 'BLACK_FRIDAY',
  LOGIN_SUCCESS_QS: 'mission_success=login',
  DOWNLOAD_APP_URL: 'https://promobit.onelink.me/OPOZ/minhabf20251',
  STORE_PAGE_ML: 'https://www.promobit.com.br/promocoes/loja/mercado-livre/',
};

export default BLACK_FRIDAY;
